// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IIsCipRequiredPropertyDto
 */
export interface IIsCipRequiredPropertyDto {
    /**
     * 
     * @type {boolean}
     * @memberof IIsCipRequiredPropertyDto
     */
    is_cip_required?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IIsCipRequiredPropertyDto
     */
    is_cip_required_state?: IIsCipRequiredPropertyDtoIsCipRequiredStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IIsCipRequiredPropertyDtoIsCipRequiredStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IIsCipRequiredPropertyDto interface.
 */
export function instanceOfIIsCipRequiredPropertyDto(value: object): value is IIsCipRequiredPropertyDto {
    return true;
}

export function IIsCipRequiredPropertyDtoFromJSON(json: any): IIsCipRequiredPropertyDto {
    return IIsCipRequiredPropertyDtoFromJSONTyped(json, false);
}

export function IIsCipRequiredPropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IIsCipRequiredPropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'is_cip_required': json['is_cip_required'] == null ? undefined : json['is_cip_required'],
        'is_cip_required_state': json['is_cip_required_state'] == null ? undefined : json['is_cip_required_state'],
    };
}

export function IIsCipRequiredPropertyDtoToJSON(json: any): IIsCipRequiredPropertyDto {
    return IIsCipRequiredPropertyDtoToJSONTyped(json, false);
}

export function IIsCipRequiredPropertyDtoToJSONTyped(value?: IIsCipRequiredPropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'is_cip_required': value['is_cip_required'],
        'is_cip_required_state': value['is_cip_required_state'],
    };
}

